import React, { useEffect, useState } from 'react';
import PageMainBanner from '../../comps/PageMainBanner';
import Footer from '../../comps/Footer';
import Header from '../../comps/Header';
import { get_development, get_main_banner_section } from '../../api/Global';
import { IMG_BASE_URL } from '../../config/Base_Url_Config';
import Web_Development_Feature from './Web_Development_Feature';
import Web_Development_Projects from './Web_Development_Projects';
import web_development from '../../assets/images/web-development.svg';
import More_Hosting from '../more_hosting/More_Hosting';

const Web_Development = () => {
    const [get_banner_list, set_Banner_List] = useState([]);
    const [get_development_list, set_development] = useState([]);

    // <----------- render the main banner section ---------->
    useEffect(() => {
        const handle_get_main_banner_section = async () => {
            try {
                const response = await get_main_banner_section();
                set_Banner_List(response?.data?.data?.banners)
            } catch (error) {
                console.log("error", error)
            }
        }
        handle_get_main_banner_section();
    }, [])

    // <----------- render the main banner section ---------->
    useEffect(() => {
        const handle_get_main_banner_section = async () => {
            try {
                const response = await get_development();
                
                set_development(response?.data?.data?.developments)
            } catch (error) {
                console.log("error", error)
            }
        }
        handle_get_main_banner_section();
    }, [])
    return (
        <div>
            <Header />
            <PageMainBanner heading="Web Development" title={get_banner_list?.development_title} para={get_banner_list?.development_description} image={get_banner_list?.development_image ? `${IMG_BASE_URL}/${get_banner_list.development_image}` : web_development} />
            {/*  */}
            <br/>
            <br/>
            <Web_Development_Projects data={get_development_list} />
            {/*  */}
            <Web_Development_Feature data={get_development_list} />
            {/*  */}
            <More_Hosting/>
            <Footer />
        </div>
    )
}

export default Web_Development